
import { useAnimations, useGLTF } from "@react-three/drei"
import armsUrl from "./assets/models/arms/arms.glb"
import { useEffect } from "react"

export default function Axe(props) {
  const model= useGLTF(armsUrl)
  const { actions } = useAnimations(model.animations, model.scene);

  useEffect(() => {
    if (actions && actions[Object.keys(actions)[0]]) {
      actions[Object.keys(actions)[1]].play(); // Запуск першої анімації
    }
  }, [actions]);

  return (
    <group dispose={null} {...props}>
      <group>
        <primitive object={model.scene} />
      </group>
    </group>
  )
}

useGLTF.preload("/axe.glb")
